// extracted by mini-css-extract-plugin
export default {"box":"WeatherMain_box__fc2uI","weathercontainer":"WeatherMain_weathercontainer__SHCV1","cont":"WeatherMain_cont__NazEb"};